import type { HomeTask } from "./types";

const RISK_ORDER = { high: 0, medium: 1, low: 2 } as const;

/** Rank tasks: SLA pressure → risk → blocking → age. */
export function rankHomeTasks(tasks: HomeTask[]): HomeTask[] {
  return [...tasks]
    .filter((t) => !t.completed)
    .sort((a, b) => {
      if (a.slaMinutesRemaining !== b.slaMinutesRemaining) {
        return a.slaMinutesRemaining - b.slaMinutesRemaining;
      }
      if (RISK_ORDER[a.risk] !== RISK_ORDER[b.risk]) {
        return RISK_ORDER[a.risk] - RISK_ORDER[b.risk];
      }
      if (a.blockingSomeone !== b.blockingSomeone) {
        return a.blockingSomeone ? -1 : 1;
      }
      return b.ageHours - a.ageHours;
    });
}

/** Rank completed tasks by most recently cleared first. */
export function listCompletedTasks(tasks: HomeTask[]): HomeTask[] {
  return [...tasks]
    .filter((t) => t.completed)
    .sort((a, b) => a.ageHours - b.ageHours);
}

export function formatSlaLabel(minutes: number): string {
  if (minutes < 60) return `SLA ${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `SLA ${hours}h`;
  return `SLA ${Math.floor(hours / 24)}d`;
}

export function taskTypeGlyph(type: HomeTask["hitlType"]): string {
  switch (type) {
    case "authorise":
      return "✓";
    case "decide":
      return "?";
    case "review":
      return "◎";
    default:
      return "·";
  }
}

export const CATEGORY_LABELS: Record<HomeTask["category"], string> = {
  letter: "Letter",
  crm_updates: "CRM updates",
  handover_notes: "Handover notes",
  narrative_review: "Narrative",
  other: "Task",
};
